<template>
  <component :is="tag" v-if="tag" v-html="htmlValue" />
  <template v-else>
    {{ htmlValue }}
  </template>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { applyReplacementTags } from '@/utilities/Utilities';
import { ReplacementTags } from '@/store/modules/global/state';

type TagTypes = 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p';

export default defineComponent({
  name: 'ApplyReplacementTags',
  props: {
    html: {
      type: String,
      required: true
    },
    extraReplacementTags: {
      type: Object as PropType<ReplacementTags>,
      required: false
    },
    tag: {
      type: String as PropType<TagTypes>
    }
  },
  setup(props) {
    const htmlValue = computed(() => {
      return applyReplacementTags(props.html, props.extraReplacementTags);
    });

    return { htmlValue };
  }
});
</script>

<style scoped></style>
